/*!
 * FrontAlign v1.0.9
 * (c) Eyruz Badalzada
 * Released under the MIT License
 * https://www.frontalign.dev
 */

import { useEffect, useRef } from "react";
import Components from "../js/core/Component.js";

/**
 * useTabview
 * Initializes a Tabview instance for the returned ref.
 */
export function useTabview() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const instance = Components.tabview(el);

    return () => {
      instance?.dispose?.();
    };
  }, []);

  return ref;
}

/**
 * useSwiper
 * Initializes pointer-based drag/swipe behavior on the returned ref.
 */
export function useSwiper() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const instance = Components.swiper(el);

    return () => {
      instance?.dispose?.();
    };
  }, []);

  return ref;
}

/**
 * useBadge
 * Formats badge counters and limits values above 99 to "99+"
 */
export function useBadge(count) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    Components.badge(el);
  }, [count]);

  return ref;
}
